/* eslint no-console: 0, no-underscore-dangle: 0 */
import { isSodimacStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import React from 'react';
import constants from '../../config/constants';
import { getAdInjectorEnabled } from '../../containers/ProductContainer/utils';
import { withApplicationContext } from '../../utils/ApplicationContext';
import _ from '../../utils/LodashImports';
import { noop } from '../../utils/noop';
import { mapATGPricesToCatalystPrices } from '../../utils/PriceHelpers';
import { recoAnalytics } from '../../utils/recoAnalytics';
import GoogleAdComponent from '../GoogleAds';
import Carousel from '../ui/Carousel/Carousel';
import Heading from '../ui/Heading/Heading';
import MatchMedia from '../ui/MatchMedia/MatchMedia';
import { ProductCarouselStyles } from './ProductsCarousel.style';
import ProductsCarouselPod from './ProductsCarouselPod/ProductsCarouselPod';

const ProductsCarousel = ({
  products,
  appCtx,
  heading,
  subHeading,
  carouselPosition,
  parentVariantID,
  handleViewedProducts,
  isSponsored,
  sponsoredClick,
  parentProductGcategory,
  slotId,
  carouselId,
}) => {
  const uniqueViewedProducts = new Set();
  const { regionCode, deviceType } = appCtx;
  const toggles = _.get(appCtx, 'siteConfig.toggles', {});
  const carouselRecoRef = React.useRef(null);
  const mProducts = products.map((product) => ({
    ...product,
    prices: mapATGPricesToCatalystPrices(product.prices, regionCode, toggles),
  }));
  const adInjectorIsEnabled = getAdInjectorEnabled(appCtx);
  const adTypeCarousel =
    subHeading === constants.SPONSORED_PRODUCTS_CAROUSEL_SUB_HEADING ? 'sponsored_carousel' : 'hybrid_carousel';
  const aggregateViewedProducts = (id) => {
    if (isSponsored && uniqueViewedProducts.has(id)) return false;
    uniqueViewedProducts.add(id);
    if (isSodimacStandalone(appCtx.store) && !isSponsored) {
      recoAnalytics.impression({
        carouselName: heading,
        skusViewed: [id],
      });
      return false;
    }
    const payloadTitle = heading.split(' ').join('_');
    const skus = Array.from(uniqueViewedProducts).join(',');

    handleViewedProducts(payloadTitle, skus);

    return false;
  };
  const renderProductsCarouselPod = () => {
    return mProducts.map((item, index) => (
      <ProductsCarouselPod
        key={item.productId}
        product={item}
        appCtx={appCtx}
        aggregateViewedProducts={aggregateViewedProducts}
        details={{
          numberProducts: mProducts.length,
          productPosition: index + 1,
          carouselPosition,
          carouselName: heading,
          parentVariantID,
          slotId,
          adType: adTypeCarousel ?? 'carousel',
          carouselId,
        }}
        isSponsored={isSponsored}
        sponsoredClick={sponsoredClick}
      />
    ));
  };

  const showRecommendationsWrapper = mProducts.length > 0;
  const showSlideButton = products.length > 6;
  return (
    showRecommendationsWrapper && (
      <div data-widget-name={heading} ref={carouselRecoRef} className="products-carousel-wrapper">
        <div className="products-carousel-heading">
          <Heading variation={isSponsored ? 'title15' : 'title14'} level="2">
            {heading}
          </Heading>
          <h2 hidden={!subHeading} className="products-carousel-sub-heading">
            {subHeading}
          </h2>
        </div>
        <MatchMedia
          content={{
            mobile: () => (
              <Carousel
                items={renderProductsCarouselPod()}
                itemsPerSlide={2}
                minimumItemWidth={240}
                navButtonsVisible={false}
                isForProductsCarousel
                heading={heading}
                carouselPosition={carouselPosition}
                showSlideButton={showSlideButton}
                showIndictors={!isSponsored}
              />
            ),
            tablet: () => (
              <Carousel
                items={renderProductsCarouselPod()}
                itemsPerSlide={4}
                navButtonsVisible={false}
                isForProductsCarousel
                heading={heading}
                carouselPosition={carouselPosition}
                showSlideButton={showSlideButton}
                showIndictors
              />
            ),
            desktop: () => (
              <Carousel
                items={renderProductsCarouselPod()}
                itemsPerSlide={6}
                navButtonsVisible
                isForProductsCarousel
                heading={heading}
                carouselPosition={carouselPosition}
                showSlideButton={showSlideButton}
                showIndictors
              />
            ),
          }}
        />
        {adInjectorIsEnabled && (
          <div className="google-ad-experiment-1" style={{ display: 'none' }}>
            <GoogleAdComponent
              adsPosition={constants.GOOGLE_AD_POSITION.V1}
              deviceType={deviceType}
              productGcategory={parentProductGcategory}
            />
          </div>
        )}
        <style jsx>{ProductCarouselStyles}</style>
      </div>
    )
  );
};
ProductsCarousel.defaultProps = {
  handleViewedProducts: noop,
  isSponsored: false,
  sponsoredClick: noop,
  parentProductGcategory: '',
  slotId: '',
  carouselId: '',
};

ProductsCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  appCtx: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  carouselPosition: PropTypes.string.isRequired,
  parentVariantID: PropTypes.number.isRequired,
  handleViewedProducts: PropTypes.func,
  isSponsored: PropTypes.bool,
  sponsoredClick: PropTypes.func,
  parentProductGcategory: PropTypes.string,
  slotId: PropTypes.string,
  carouselId: PropTypes.string,
};

export default withApplicationContext(ProductsCarousel);
export { ProductsCarousel };
